module.exports = __webpack_public_path__ + "img/pro_cankao.8f8ad1f8.svg";